import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { Column, Row } from "simple-flexbox";
import CheckIcon from "@material-ui/icons/Check";
import { StyleSheet, css } from "aphrodite";
import { withRouter } from "react-router-dom";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import {
  renderInputWithLabel,
  renderFile,
} from "../../components/form/FormComponent";
import { approvalTransrs } from "../../actions/transrs/transrs_action";
import {
  getTransrsAdd,
  getTransrsAddPending,
  getTransrsAddError,
} from "../../reducers/transrs/transrs_reducer";

class ModalRejectTransRS extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(values) {
    const { approvalTransrs, onHide, handleRefresh, id } = this.props;
    let formData = new FormData();
    formData.append("id", id);
    formData.append("is_approve", "false");
    formData.append("reject_notes", values.reject_notes);
    // Menambahkan nilai reject_file hanya jika filenya tidak kosong
    if (values.reject_file instanceof File) {
      formData.append("reject_file", values.reject_file);
    }

    const callback = () => {
      onHide();
      handleRefresh();
    };
    approvalTransrs(formData, callback);
  }

  render() {
    const { handleSubmit, show, onHide, approvalTransrs_pending } = this.props;
    return (
      <Modal
        show={show}
        onHide={onHide}
        cityOption={this.props.cityOption}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <p style={{ fontSize: 20, fontWeight: 600 }}>Konfirmasi Trans RS</p>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={handleSubmit(this.handleSubmit)}
            style={{ width: "100%" }}
          >
            <Column
              vertical="center"
              horizontal="stretch"
              className={css(styles.bodyModal)}
            >
              <>
                <Field
                  name="reject_notes"
                  placeholder="Masukkan alasan penolakan"
                  label="Alasan Penolakan"
                  component={renderInputWithLabel}
                />
                <Field
                  name="reject_file"
                  type="file"
                  fileType="image" //image or pdf
                  title="upload berkas"
                  message="PNG atau JPG maksimal 500 kb"
                  component={renderFile}
                />
              </>
            </Column>
            <Row
              horizontal="flex-end"
              vertical="center"
              className={css(styles.footerModal)}
            >
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={approvalTransrs_pending}
                className={css(styles.approveButton)}
                startIcon={
                  approvalTransrs_pending ? (
                    <CircularProgress size={14} color="secondary" />
                  ) : (
                    <CheckIcon />
                  )
                }
              >
                simpan
              </Button>
            </Row>
          </form>
        </Modal.Body>
      </Modal>
    );
  }
}

const styles = StyleSheet.create({
  approveButton: {
    background: "#2CB96A 0% 0% no-repeat padding-box",
    boxShadow: "none",
  },
  rejectButton: {
    background: "#EAEBED 0% 0% no-repeat padding-box",
    marginRight: 10,
    color: "#495057",
    boxShadow: "none",
  },
  footerModal: {
    backgroundColor: "#FBFBFD",
    padding: "20px 40px",
  },
  bodyModal: {
    padding: "0px 40px 20px",
    width: "100%",
  },
});

function validate(values) {
  const maxFileSize = 500000; //500kb
  const imageType = ["image/png", "image/jpeg"];
  const { reject_file, reject_notes } = values;
  const errors = {};
  if (!reject_notes) {
    errors.reject_notes = "Alasan penolakan wajib diisi";
  }
  //   if (!reject_file) {
  //     errors.reject_file = "berkas wajib diisi";
  //   }
  if (
    values.reject_file &&
    values.reject_file.type !== imageType[0] &&
    values.reject_file.type !== imageType[1]
  ) {
    errors.reject_file = "Format file hanya bisa PNG/JPG/JPEG";
  } else if (values.reject_file && values.reject_file.size > maxFileSize) {
    errors.reject_file = "File lebih dari 500KB";
  }
  return errors;
}

ModalRejectTransRS = reduxForm({
  form: "ModalRejectTransRS",
  validate: validate,
  shouldError: () => true,
  enableReinitialize: true,
})(ModalRejectTransRS);

function mapStateToProps({ approvalTransrs }) {
  return {
    approvalTransrs_pending: getTransrsAddPending(approvalTransrs),
    approvalTransrs_data: getTransrsAdd(approvalTransrs),
    approvalTransrs_error: getTransrsAddError(approvalTransrs),
  };
}

export default connect(mapStateToProps, {
  approvalTransrs,
})(withRouter(ModalRejectTransRS));
